import ReactGA from "react-ga4";

// Identifiant de mesure Google Analytics 4
const GA_MEASUREMENT_ID = "G-DJE0RJ2XHC";

// Active GA4 (uniquement après consentement) et compte la page en cours.
// send_page_view: false -> GA4 n'envoie pas sa propre page vue automatique,
// sinon la première page serait comptée deux fois (on les envoie nous-mêmes).
export const initAnalytics = () => {
  if (ReactGA.isInitialized) return;
  ReactGA.initialize(GA_MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
  trackPageView(window.location.pathname + window.location.search);
};

// Page vue : ignorée tant que le visiteur n'a pas accepté les cookies
export const trackPageView = (page) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.send({ hitType: "pageview", page });
};

// Événement personnalisé : ignoré tant que le visiteur n'a pas accepté les cookies
export const trackEvent = (name, params = {}) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.event(name, params);
};
